import axios, { type AxiosInstance } from 'axios';
import { env } from '@/utils/env';
import { newRequestId } from '@/utils/request-id';
import { toApiError } from './api-error';

export const REQUEST_ID_HEADER = 'X-Request-Id';

/** An axios instance with the conventions every Bovid API call shares. */
export function createHttp(timeout: number): AxiosInstance {
  const http = axios.create({
    baseURL: env.apiBaseUrl,
    timeout,
    headers: { Accept: 'application/json' },
  });
  http.interceptors.request.use((config) => {
    config.headers.set(REQUEST_ID_HEADER, newRequestId());
    return config;
  });
  return http;
}

/** Rejects with ApiError instead of AxiosError. Register as the last response interceptor. */
export function rejectWithApiError(http: AxiosInstance): void {
  http.interceptors.response.use(undefined, (error: unknown) => Promise.reject(toApiError(error)));
}
